module.exports = __webpack_public_path__ + "media/images/manifest/microbius-120-867c6c284db5a7747d2f06fa4b016ae9.png";